import React from 'react';
import { useQuery } from '../graphql/hooks';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import QcPicker from './QcPicker';
import FormulasList from './FormulasList';
import TestingSetupManager from './TestingSetupManager';
import SimplePosition from '../teal-react/components/atoms/SimplePosition';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import ExcludeReadOnly from './Auth/ExcludeReadOnly';

interface ProductViewerProps {
  product_id: number;
  onQcSelect: (id: number) => void;
  onEdit: (p: any) => void;
}

const ProductViewer = ({
  product_id,
  onQcSelect,
  onEdit,
}: ProductViewerProps) => {
  const [tab, setTab] = React.useState(1);
  const { data } = useQuery(
    `query ProductViewer($where: String){
      product(where: $where){
        id
        name
        shortname
        shelflife
        code
      }
    }`,
    {
      variables: { where: JSON.stringify({ id: product_id }) },
    }
  );

  if (!data) {
    return null;
  }
  const product = data.product[0];
  return (
    <div>
      <ExcludeReadOnly>
        <SimplePosition position="top right" padding={20}>
          <IconButton size="small" onClick={() => onEdit(product)}>
            <Edit color="primary" />
          </IconButton>
        </SimplePosition>
      </ExcludeReadOnly>
      <SimpleCard
        header={product.name}
        subheader={`[${product.code}] ${product.shortname || ''}`}
        activeTab={tab - 1}
        tabs={[
          { label: 'Batch Reports', onClick: () => setTab(1) },
          { label: 'Formula', onClick: () => setTab(2) },
          { label: 'Testing Setup', onClick: () => setTab(3) },
        ]}
      >
        {tab === 1 ? (
          <QcPicker
            product_id={product?.id}
            onSelect={(t: any) => {
              onQcSelect(t.id);
            }}
          />
        ) : null}
        {tab === 2 ? <FormulasList product_id={product?.id} /> : null}
        {tab === 3 ? <TestingSetupManager product_id={product?.id} /> : null}
      </SimpleCard>
    </div>
  );
};

export default ProductViewer;
